export function getLastWallet(): string | null {
  const storageKey = Object.keys(localStorage).find(sk => sk.startsWith('starknetLastConnectedWallet'));
  if (storageKey) {
    return localStorage.getItem(storageKey);
  }
  return null;
}
